export const dashboardStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500;600&display=swap');

  .db-page * { box-sizing: border-box; }

  .db-page {
    min-height: 100vh;
    background: #eaf1fd;
    font-family: 'Sora', sans-serif;
    padding-bottom: 80px;
  }

  

  /* ── LAYOUT ── */
  .db-layout {
    display: grid;
    grid-template-columns: 1fr 300px;
    gap: 1.5rem;
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 1.5rem;
   
  }
  .db-left { display: flex; flex-direction: column; gap: 1.25rem; min-width: 0; margin-top: 55px; }
  .db-right { display: flex; flex-direction: column; gap: 1.25rem; margin-top: 55px; }

  /* ── CARDS ── */
  .db-card {
    background: #fff;
    border-radius: 20px;
    padding: 1.5rem 1.75rem;
    box-shadow: 0 2px 20px rgba(15,28,46,0.06);
    border: 1px solid rgba(255,255,255,0.9);
  }
  .db-card-dark {
    background: #0f1c2e;
    border-radius: 20px;
    padding: 1.5rem 1.75rem;
    position: relative; overflow: hidden;
  }
  .db-card-dark-blob1 {
    position: absolute; width: 220px; height: 220px; border-radius: 50%;
    background: radial-gradient(circle, rgba(55,138,221,0.2) 0%, transparent 70%);
    top: -60px; right: -40px; pointer-events: none;
  }
  .db-card-dark-blob2 {
    position: absolute; width: 160px; height: 160px; border-radius: 50%;
    background: radial-gradient(circle, rgba(249,115,22,0.15) 0%, transparent 70%);
    bottom: -30px; left: -30px; pointer-events: none;
  }
  .db-card-dark-grid {
    position: absolute; inset: 0;
    background-image: linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px),
                      linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px);
    background-size: 36px 36px; pointer-events: none;
  }
  .db-card-inner { position: relative; z-index: 1; }

  /* ── SECTION TITLE ── */
  .db-section-title {
    font-size: 11px; font-weight: 600; letter-spacing: 0.7px;
    text-transform: uppercase; color: #9aaabb;
    margin-bottom: 1rem;
    display: flex; align-items: center; gap: 8px;
  }
  .db-section-title::after { content: ''; flex: 1; height: 1px; background: #e8eef7; }

  /* ── FIELD LABEL ── */
  .db-field-label { font-size: 10.5px; color: #9aaabb; text-transform: uppercase; letter-spacing: 0.4px; margin-bottom: 3px; }
  .db-field-val { font-size: 13.5px; font-weight: 500; color: #0f1c2e; }

  /* ── BADGE ── */
  .db-badge {
    display: inline-flex; align-items: center; gap: 5px;
    padding: 3px 10px; border-radius: 20px;
    font-size: 11px; font-weight: 600;
  }
  .db-badge.orange { background: rgba(249,115,22,0.1); color: #F97316; border: 1px solid rgba(249,115,22,0.25); }
  .db-badge.green { background: rgba(52,211,153,0.1); color: #059669; border: 1px solid rgba(52,211,153,0.25); }
  .db-badge.blue { background: rgba(55,138,221,0.1); color: #378ADD; border: 1px solid rgba(55,138,221,0.25); }
  .db-badge.warn { background: rgba(251,191,36,0.1); color: #d97706; border: 1px solid rgba(251,191,36,0.3); }

  /* ── BUTTONS ── */
  .db-btn {
    display: inline-flex; align-items: center; gap: 7px;
    padding: 9px 18px; border-radius: 10px; border: none;
    font-family: 'Sora', sans-serif;
    font-size: 13px; font-weight: 600; cursor: pointer;
    text-decoration: none; transition: background 0.15s, transform 0.1s;
  }
  .db-btn svg { width: 15px; height: 15px; }
  .db-btn-orange { background: #F97316; color: #fff; box-shadow: 0 3px 12px rgba(249,115,22,0.28); }
  .db-btn-orange:hover { background: #ea6a0a; color: #fff; text-decoration: none; }
  .db-btn-dark { background: #0f1c2e; color: #fff; }
  .db-btn-dark:hover { background: #1a2f4a; color: #fff; text-decoration: none; }
  .db-btn-outline { background: transparent; border: 1.5px solid #dce4f0; color: #4a5568; }
  .db-btn-outline:hover { border-color: #b8cce8; }

  /* ── INPUT ── */
  .db-input {
    width: 100%; height: 44px;
    border: 1.5px solid #dce4f0; border-radius: 11px;
    background: #f7f9fc; padding: 0 14px;
    font-family: 'Sora', sans-serif;
    font-size: 13.5px; color: #0f1c2e; outline: none;
    transition: border-color 0.15s, box-shadow 0.15s;
  }
  .db-input:focus { border-color: #378ADD; box-shadow: 0 0 0 3px rgba(55,138,221,0.12); background: #fff; }
  .db-select { appearance: none; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7a90' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: right 12px center; padding-right: 36px; cursor: pointer; }

  /* ── RESPONSIVE ── */
  @media (max-width: 960px) {
    .db-layout { grid-template-columns: 1fr; }
    .db-right { order: -1; }
  }
  @media (max-width: 600px) {
    .db-layout { padding: 1rem; gap: 1rem; }
    .db-card { padding: 1.25rem; }
  }
`;
